import { Col, Image } from 'react-bootstrap';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { getRoutesDirections } from '@/data/libraries/RoutesTranslated';
import { getUrlFromCssVariable } from '@/domain/utils/CssToImage';
import { getCSSVariableValue } from '@/domain/utils/CssExtractVariable';

/** Componente Columna Logo */
const ColumnLogo = (): JSX.Element => {


    /** URL del logo de footer */
    const LOGO = getUrlFromCssVariable('--img-logo-footer');

    const showTextVariable = getCSSVariableValue('--show-text-footer-color-variant-light') === 'true';

    /** Hook para generar una navegación dentro de la aplicación. */
    const navigate: NavigateFunction = useNavigate();

    /** Rutas URLs */
    const routesDirections = getRoutesDirections();

    /** Renderiza el componente principal */
    return (
        <Col>
            <ul className={`${showTextVariable ? 'text-primary-4' : 'text-secondary-1'} list-unstyled mx-auto`}>
                <div className='text-center pt-4'>
                    <Image
                        id='logo'
                        src={LOGO}
                        alt='logo'
                        className='logo-footer'
                        onClick={() => navigate(routesDirections.MAIN_ROUTE)}
                    />
                </div>
            </ul>
        </Col>

    );
}

export default ColumnLogo;